export type PointsTranslateFn = (key: string, params?: Record<string, string>) => string

/** Abbreviated unit: "pt" for 0 or 1, "pts" otherwise. */
export function pointsAbbrev(count: number | string | null | undefined, t: PointsTranslateFn): string {
  const n = Number(count)
  if (!Number.isFinite(n) || n === 0 || n === 1) return t('roomPage.pt')
  return t('roomPage.pts')
}

/** e.g. "0 pt", "1 pt", "4 pts" */
export function formatPoints(count: number | string | null | undefined, t: PointsTranslateFn): string {
  const n = Number(count)
  const value = Number.isFinite(n) ? n : 0
  return `${value} ${pointsAbbrev(value, t)}`
}

/** e.g. "4 / 6 pts" */
export function formatEarnedPossible(
  earned: number | string | null | undefined,
  possible: number | string | null | undefined,
  t: PointsTranslateFn,
): string {
  const e = Number(earned)
  const p = Number(possible)
  const earnedN = Number.isFinite(e) ? e : 0
  const possibleN = Number.isFinite(p) ? p : 0
  const unit = pointsAbbrev(possibleN > 1 ? possibleN : earnedN, t)
  return `${earnedN} / ${possibleN} ${unit}`
}
